import {useTranslation} from "react-i18next"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"
import useTeam from "../../swrCustomHooks/useTeam"
import {toast} from "react-toastify"
import isLicenceValidity from "../../tools/isLicenceValidity"

export default function AddProjectBtn({type}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {setStProjectsAction} = useStProjectsContext()
    const {setEcpProjectsAction} = useEcpProjectsContext()
    const {team, isLoadingTeam, isErrorTeam} = useTeam(sessionContext.idTeam)
    const {teamContext} = useTeamContext()

    const handleClick = () => {
        const errorMessage = t("Not enough credit. Please liaise with the Neurowide sales department.")
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            if (type === "st") {
                team.team.nb_credits > 0 ? setStProjectsAction({type: "ST_PROJECTS_IS_MODAL", payload: {isModal: true}}) : toast.error(errorMessage)
            } else if (type === "ecp") {
                team.team.nb_credits_ecp > 0 ? setEcpProjectsAction({type: "ECP_PROJECTS_IS_MODAL", payload: {isModal: true}}) : toast.error(errorMessage)
            }
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    if (isErrorTeam || isLoadingTeam || team?.message) return null
    return (
        <>
        <button className="add-project-btn" onClick={handleClick} title={t("Create a project")}>{t("Create project")}</button>
        </>
    )
}